module.exports = __webpack_public_path__ + "img/br.958c8b3.svg";